import { useEffect, useState } from "react";
import { UnoStoreHooks } from "@simulanisindia/ui";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import apiClient from "../../apiClient";
import { ALLOCATE_RESOURCE_SIDEBAR } from "../../apiClient/apiEndpoints";
import {
  AR_CONTENT_TAB,
  RESOURCE_APPLICATION_TAB,
  RESOURCE_ENVIRONMENT_TAB,
  RESOURCE_MODULE_TAB,
  RESOURCE_SKILL_SCHOOL_TAB,
  RESOURCE_SKILL_STREAM_TAB,
} from "../../constant/constants";
import { makeFilterParams, visibleAssignSectionList } from "../../utils/general";
import useDebounce from "../../hooks/useDebounce";
import { useSelector } from "react-redux";

const { useUnoSelector } = UnoStoreHooks;

const ResourceSidebar_N = ({ setActiveTab, activeTab, checkedFilterItem, search }) => {
  const userData = useUnoSelector((state) => state.user);
  const configData = useUnoSelector((state) => state.config);
  const filterOptions = useSelector((state) => state.filterOptions);
  const [listIcon] = useState(false);
  const [sideTabList, setSideTabList] = useState([]);
  const [loading, setLoading] = useState(false);

  let queryCheckedItem = useDebounce(checkedFilterItem, 550);
  let querySearchItem = useDebounce(search, 550);

  const handleGetSideBarList = async () => {
    setLoading(true);
    try {
      let queryParams = {
        [RESOURCE_APPLICATION_TAB]: {
          search: search[RESOURCE_APPLICATION_TAB],
          tagIds: [],
          platforms: [],
          categoryIds: [],
          ...makeFilterParams(checkedFilterItem[RESOURCE_APPLICATION_TAB]),
        },
        [RESOURCE_MODULE_TAB]: {
          search: search[RESOURCE_MODULE_TAB],
          tagIds: [],
          platforms: [],
          categoryIds: [],
          ...makeFilterParams(checkedFilterItem[RESOURCE_MODULE_TAB]),
        },
        [RESOURCE_ENVIRONMENT_TAB]: {
          search: search[RESOURCE_ENVIRONMENT_TAB],
          tagIds: [],
          platforms: [],
          categoryIds: [],
          ...makeFilterParams(checkedFilterItem[RESOURCE_ENVIRONMENT_TAB]),
        },
        [RESOURCE_SKILL_STREAM_TAB]: {
          search: search[RESOURCE_SKILL_STREAM_TAB],
          tagIds: [],
          platforms: [],
          categoryIds: [],
          ...makeFilterParams(checkedFilterItem[RESOURCE_SKILL_STREAM_TAB]),
        },
        [RESOURCE_SKILL_SCHOOL_TAB]: {
          search: search[RESOURCE_SKILL_SCHOOL_TAB],
          tagIds: [],
          platforms: [],
          categoryIds: [],
          ...makeFilterParams(checkedFilterItem[RESOURCE_SKILL_SCHOOL_TAB]),
        },
        [AR_CONTENT_TAB]: {
          search: search[AR_CONTENT_TAB],
          tagIds: [],
          platforms: [],
          categoryIds: [],
          ...makeFilterParams(checkedFilterItem[AR_CONTENT_TAB]),
        },
      };

      const data = await apiClient.get(
        `${configData.config.UNO_URL}${ALLOCATE_RESOURCE_SIDEBAR}/${userData.user.uuid}`,
        {
          // params: {
          //   ...queryParams
          // }
        }
      );
      let list = data.list;
      let _visibleAssignSectionList = visibleAssignSectionList();
      const filteredList = list.filter(item =>
        _visibleAssignSectionList.some(v => v.id_link === item.id_link)
      );
      setSideTabList(filteredList);

      setActiveTab((pre) => (!pre ? (filteredList.length > 0 ? filteredList[0].id_link : null) : pre));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleGetSideBarList();
  }, []);

  const handleItemClick = (item) => {
    setActiveTab(item.id_link);
    const section = document.getElementById(item.id_link);
    if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <>
      {loading ? (
        <div style={{ position: "sticky", top: "100px" }}>
          <ul className="uilist">
            {Array(5).fill(0).map((_, index) => (
              <li key={index} className="sim-list-item">
                <span className="sim-list-title w-100">
                  <Skeleton width="100%" height={26} />
                </span>

              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div style={{ position: "sticky", top: "100px" }}>
          <ul className="uilist">
            {sideTabList.map((item, index) => (
              <li
                key={index}
                className={`sim-list-item ${activeTab === item.id_link ? "active" : ""}`}
                onClick={() => handleItemClick(item)}
              >
                <span className="sim-list-title">
                  {listIcon && item.icon}
                  {item.title}
                </span>
                <span className="sim-list-count">{filterOptions.total[item.id_link]}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default ResourceSidebar_N;
